/* web/app/components/social-share/social-share.component.scss */
::ng-deep .social-wrapper .share-btn button {
  margin: 0;
}
::ng-deep .social-wrapper .share-btn button .sb-content {
  margin-inline: auto;
}
/*# sourceMappingURL=social-share.component.css.map */
